import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./TournamentResults.css";

const TournamentResults = () => {
  const [tournaments, setTournaments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [eventsPerPage, setEventsPerPage] = useState(5); // Default to 5 events per page
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTournaments = async () => {
        try {
            const response = await fetch("/tournaments.json");
            const data = await response.json();

            // Convert date format from YYYYMMDD to YYYY-MM-DD
            const parseDate = (date) => {
                const year = date.slice(0, 4);
                const month = date.slice(4, 6);
                const day = date.slice(6, 8);
                return `${year}-${month}-${day}`;
            };

            const sortedTournaments = data
                .map(tournament => ({
                    ...tournament,
                    date: parseDate(tournament.date), // Convert to a valid date format
                }))
                .sort((a, b) => new Date(b.date) - new Date(a.date)); // Sort by most recent

            setTournaments(sortedTournaments);
        } catch (error) {
            console.error("Error fetching tournaments:", error);
        } finally {
            setLoading(false);
        }
    };

    fetchTournaments();
}, []);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEventsPerPageChange = (e) => {
    setEventsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to the first page
  };

  if (loading) return <div>Loading...</div>;

  const totalPages = Math.ceil(tournaments.length / eventsPerPage);
  const displayedTournaments = tournaments.slice(
    (currentPage - 1) * eventsPerPage,
    currentPage * eventsPerPage
  );

  return (
    <div className="tournament-results">
      <h1>Tournament Results</h1>

      {/* Events Per Page Dropdown */}
      <div className="events-per-page">
        <label htmlFor="eventsPerPage">Events per page:</label>
        <select
          id="eventsPerPage"
          value={eventsPerPage}
          onChange={handleEventsPerPageChange}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
        </select>
      </div>

      {/* Tournament Cards */}
      {displayedTournaments.map((tournament, index) => (
        <div className="tournament-card" key={index}>
          <h2>{tournament.event}</h2>
          <p><strong>Date:</strong> {tournament.date}</p>
          <p><strong>Players:</strong> {tournament.players}</p>
          <h3>Top Decks</h3>
          <div className="deck-list">
            {tournament.decklists.slice(0, 8).map((deck, rank) => (
              <div className="deck-entry" key={rank}>
                <span className="deck-rank">{rank + 1}.</span>
                <Link
                  to={deck.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="deck-link"
                >
                  {deck.archetype || "Unknown Archetype"}
                </Link>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Pagination */}
      <div className="pagination">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            className={`page-button ${currentPage === i + 1 ? "active" : ""}`}
            onClick={() => handlePageChange(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TournamentResults;